import { render, staticRenderFns } from "./Comissao.vue?vue&type=template&id=6a0269ac&scoped=true"
import script from "./Comissao.vue?vue&type=script&lang=js"
export * from "./Comissao.vue?vue&type=script&lang=js"
import style0 from "./Comissao.vue?vue&type=style&index=0&id=6a0269ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0269ac",
  null
  
)

export default component.exports